// extracted by mini-css-extract-plugin
export default {"cls1":"PaperAbstract-cls1_PJc","cls2":"PaperAbstract-cls2_dDo PaperAbstract-cls1_PJc"};